enum UsLegalStatus {
  citizen = 'citizen',
  permanentResident = 'permanent_resident',
  visa = 'visa',
}

export default UsLegalStatus;
